import gql from 'graphql-tag';
const WOOD_PIECES_ACTIVITY_FRAGMENT = gql `
  fragment WoodPiecesActivityFragment on WoodPiecesActivity {
    letters
    rounds {
      roundIndex
      letter
      congratulations {
        src
      }
      nowItsYourTurn {
        src
      }
      instructionAudio {
        src
      }
      completedAudio {
        src
      }
      steps {
        stepIndex
        image
        stroke
        woodPiecesPosition: position {
          r
          x
          y
        }
        audioAsset {
          src
          captions
        }
      }
    }
  }
`;
export default WOOD_PIECES_ACTIVITY_FRAGMENT;
